import * as React from "react";
const SvgHorizontalRuleOutlined = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <path fill="none" d="M0 0h24v24H0z" />
    <path fillRule="evenodd" d="M4 11h16v2H4z" />
  </svg>
);
export default SvgHorizontalRuleOutlined;
